import React, { useEffect } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { ToDashboardError } from '../../components/ui';
import { useConfig } from '../../contexts/config';
import { useCurrentProject } from '../../contexts/settings';
import BabkaLoginClientSection from './BabkaLoginClientPage';

type RouteParams = { projectId: string };

const BabkaLoginClient = ({ match, location }: RouteComponentProps): JSX.Element => {
  const { projectId } = match.params as RouteParams;
  const { error } = useCurrentProject(projectId);
  const { xsollaAnalytics } = useConfig();

  useEffect(() => {
    xsollaAnalytics.sendOpen('login_pa_module__babka_login_client__open', projectId);
  }, []);

  if (error) {
    return <ToDashboardError error={error} pageName="navigation_project__open" />;
  }

  return <BabkaLoginClientSection />;
};

export default withRouter(BabkaLoginClient);
